import { render, staticRenderFns } from "./ProjectAgreement.vue?vue&type=template&id=3acc7784&scoped=true&"
import script from "./ProjectAgreement.vue?vue&type=script&lang=js&"
export * from "./ProjectAgreement.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAgreement.vue?vue&type=style&index=0&id=3acc7784&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acc7784",
  null
  
)

export default component.exports